export default (commit, mutation, moduleName) => commit(mutation, moduleName, { root: true });
